exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".leasing .list[data-v-7ab90142] {\n  padding: 0;\n  margin: 0;\n}\n.leasing__count-message[data-v-7ab90142] {\n  display: inline-block;\n  padding-top: 25px;\n  font-size: 14px;\n}\n.leasing__count-message b[data-v-7ab90142] {\n    text-decoration: underline;\n}\n.leasing__count-message .count[data-v-7ab90142] {\n    font-size: 16px;\n}\n.leasing .empty-message[data-v-7ab90142] {\n  color: #777;\n  margin-bottom: 15px;\n  font-size: 16px;\n  line-height: 18px;\n}\n", ""]);

// exports
